// src/reducers/panelsReducer.js

// Initial state: all panels closed
export const initialPanelsState = {
  vessel: false,
  weather: false,
  voyagePlanner: false,
  rnw: false,
  gis: false,
  map: false,
}

// Action types
export const OPEN_PANEL = "OPEN_PANEL"
export const CLOSE_PANEL = "CLOSE_PANEL"
export const TOGGLE_PANEL = "TOGGLE_PANEL"

/**
 * panelsReducer
 * - OPEN_PANEL:   opens only the given panel, closes all others
 * - CLOSE_PANEL:  closes only the given panel
 * - TOGGLE_PANEL: if the panel is open, closes it; otherwise opens only that one
 */
export function panelsReducer(state = initialPanelsState, action) {
  switch (action.type) {
    case OPEN_PANEL:
      return Object.fromEntries(Object.keys(state).map((key) => [key, key === action.panel]))

    case CLOSE_PANEL:
      return { ...state, [action.panel]: false }

    case TOGGLE_PANEL:
      if (state[action.panel]) {
        // it’s already open → close it
        return { ...state, [action.panel]: false }
      } else {
        // open only this one
        return Object.fromEntries(Object.keys(state).map((key) => [key, key === action.panel]))
      }

    default:
      return state
  }
}

// Optional action creators:
export const openPanel = (panel) => ({ type: OPEN_PANEL, panel })
export const closePanel = (panel) => ({ type: CLOSE_PANEL, panel })
export const togglePanel = (panel) => ({ type: TOGGLE_PANEL, panel })
